import React, {Fragment} from "react";
import {Box, Divider, List, ListItemText} from "@mui/material";
import {RECEIVE_ALL_CHECKED_COLOR, RECEIVE_PARTIAL_CHECKED_COLOR} from "./constant";
import moment from "moment/moment";



export function purchaseInfoForDialog (purchase) {
  if(!purchase) return <div/>

  return <Fragment>
    <Box>
      {purchase.product_name}
    </Box>
    <Box>
      {`주문 - ${purchase.buyer_name_list}`}
    </Box>
    <Box>
      {`갯수 - ${purchase.buy_quantity}`}
    </Box>
  </Fragment>
}


  const arrivalHistoryRow = (row, purchase, key) => {
    let values = row.event_value.split('/')

    let recv_quantity = values[0] || 0;
    let recv_state = values[1]
    let recv_yn = values[2]
    let status_desc = null
    let status_bgcolor = null
    let status_textcolor = null
    if(recv_yn === 'Y'){
      if(recv_state === 'F'){
        status_desc = '[강제]입고됨'
      }else{
        status_desc = '입고됨'
      }

      status_bgcolor = '#002171'
      status_textcolor = 'white'
    }else{
      if(recv_quantity > 0){
        status_desc = `${recv_quantity}/${purchase.buy_quantity}`
        if(recv_quantity < purchase.buy_quantity){
          status_bgcolor = RECEIVE_PARTIAL_CHECKED_COLOR;
        }else{
          status_bgcolor = RECEIVE_ALL_CHECKED_COLOR;
          status_textcolor = 'white'
        }
      }else{
        status_desc = `입고안됨`
        status_bgcolor = 'lightgray'
      }
    }
    //입고 상태 ${recv_state},
    let center_name = row.center_name ? `[${row.center_name}] ` : ''
    let desc = `${center_name}${row.user_name}`
    return <Box key={key}>
      <Box sx={{display : 'flex', flex: 1}}>
        <Box sx={{display : 'flex', flex : 1, fontSize : 15,
          pl : 1,
          alignItems : 'center',
          backgroundColor : status_bgcolor, color : status_textcolor}}>
          {status_desc}
        </Box>
        <Box sx={{flex : 1,
          pl : 1,pt : 0.5, pb : 0.5,
          // borderBottom : 0, borderTop : 0, borderLeft : 1,
          // borderRight : 0,
          // borderStyle : 'solid', borderColor : 'lightgray'
        }}>
          <ListItemText primary={desc}
                      secondary={moment(new Date(row.create_date)).format('YY년MM월DD일 HH:mm')}/>
        </Box>

      </Box>

    </Box>
  }

export function arrivalHistoryList (history, purchase) {

  if(!history) return <div/>

  return history.length > 0 ?
    <List dense sx={{pt : 1, pb : 1, m : 0}}>
    {history.map((item, index) => (
      <Fragment>
        {arrivalHistoryRow(item, purchase, index)}
        <Divider/>
      </Fragment>
    ))}
    </List>
    :
    <Box sx={{textAlign : 'center', p: 4}}>{"변경 이력 없음"}</Box>

}